<button (click)="toggleChange.emit(!this.isToggled())">
  <pozi-toggle id="route-speed-control" [value]="isToggled()"></pozi-toggle>

  <img
    [src]="'assets/img/' + icon()"
    [alt]="icon()"
    [class.visible]="!isToggled()"
  />

  <div class="speed-bar" [class.visible]="isToggled()">
    <span>{{ minRelativeSpeedPercentage }}%</span>
    <span class="bar"></span>
    <span>{{ maxRelativeSpeedPercentage }}%</span>
  </div>
</button>
